import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from './redux';
import { Settlements } from './component';


export default connect(mapStateToProps, mapDispatchToProps)(Settlements);
